<template>
  <div class="theme-color-wrapper p-2 bans-page">
    <div class="row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-sm-0 mb-2">Bans</h2>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-3">
        <section>
          <label>Visitor First Name</label>
          <b-form-input @keypress.enter="getBans" cy="firstname"
            placeholder="enter firstname"
            v-model="filters.firstname"></b-form-input>
        </section>
      </div>
      <div class="col-3">
        <section>
          <label>Visitor Last Name</label>
          <b-form-input @keypress.enter="getBans" cy="lastname"
                        placeholder="enter lastname"
                        v-model="filters.lastname"></b-form-input>
        </section>
      </div>
      <div class="col-3">
        <section>
          <label>Visitor Email</label>
          <b-form-input @keypress.enter="getBans" cy="email"
                        placeholder="enter email"
                        v-model="filters.email"></b-form-input>
        </section>
      </div>
      <div class="col-3"></div>
      <section class="col-3 mt-1">
        <label>Before Date</label>
        <b-form-datepicker v-model="filters.before" @input="getBans"
                           today-button cy="before"
                           reset-button
                           close-button
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section class="col-3 mt-1">
        <label>After Date</label>
        <b-form-datepicker v-model="filters.after" @input="getBans"
                           today-button cy="after"
                           reset-button
                           close-button
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section class="col-3 mt-1">
        <label>Sort</label>
        <b-form-select v-model="filters.sort" @change="getBans" cy="sort">
          <b-form-select-option v-for="sort in sorts" :key="sort.value" :value="sort.value">{{sort.text}}</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-3 mt-1 d-flex flex-column justify-content-end align-items-end">
        <b-btn variant="primary" @click="getBans">Search</b-btn>
      </section>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div>
          <div class="bans-table" v-if="bans && bans.length > 0">
            <b-table
              hover
              :fields="headers"
              :items="bans"
              :current-page="currentPage"
              :per-page="null"
              :responsive="true" cy="bans-table"
            >
              <template slot="actions" slot-scope="row">
                <b-btn @click="showBanModal('modal-view-ban', row.item)" variant="primary"
                       class="btn btn-sm text-white">View
                </b-btn>
              </template>

              <template #cell(actions)="data">
                <b-btn @click="showBanModal('modal-view-ban', data.item)" variant="link">View
                </b-btn>
              </template>
            </b-table>
          </div>
          <b-row v-if="bans && bans.length > 0">
            <b-col md="6" class="my-1">
              <b-pagination @input="getBans" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage"
                            class="my-0"/>
            </b-col>
          </b-row>
          <div v-if="!bans || bans.length === 0">
            <p>No bans to show</p>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-view-ban" ref="modal-view-ban" size="md" hide-footer hide-header :clickToClose="false">
      <view-ban v-if="selectedBan" :ban="selectedBan" @close="closeModals()"></view-ban>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import BanService from '@/services/BansService';
import HelperService from '@/services/HelperService';
import ViewBan from '@/views/bans/ViewBan';

export default {
  name: 'ban-search',
  components: {
    ViewBan,
  },
  props: {},
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      bans: [],
      filters: {
        firstname: '',
        lastname: '',
        email: '',
        before: '',
        after: '',
        skip: 10,
        limit: 10,
        sort: 'start_date',
      },
      currentPage: 1,
      totalRows: 10,
      headers: [
        {label: 'Visitor', key: 'name'},
        {label: 'Start Date', key: 'start_date'},
        {label: 'End Date', key: 'end_date'},
        {label: 'Banned By', key: 'banned_by'},
        {label: '', key: 'actions'},
      ],
      selectedBan: null,
      sorts: [
        {text: 'Upcoming Start', value: 'start_date'},{text: 'Furthest Start', value: '-start_date'},
        {text: 'Upcoming End', value: 'end_date'},{text: 'Furthest end', value: '-end_date'},
      ]
    };
  },
  mounted() {
    this.getBans();
  },
  methods: {
    getBans() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;

      BanService.getBansPaginated(this.filters).then((res) => {
        this.bans = this.formatBans(res.data.data);
        this.totalRows = res.data.count;
        this.closeModals();
      }).catch((err) => {
        console.log('Error getting bans', err);
        this.$toasted.error('Error getting bans. Please refresh the page');
      }).finally(() => {
        this.loading = false;
      });
    },
    formatBans(bans) {
      return bans.map((item) => {
        const name = item.visitor ? `${item.visitor.firstname} ${item.visitor.lastname}` : '-';
        const date = {...item, name};
        date.start_date = moment(date.start_date).format('DD/MM/YYYY');
        date.end_date = moment(date.end_date).format('DD/MM/YYYY');
        return date;
      });
    },
    backRoute() {
      this.$router.go(-1);
    },
    closeModals() {
      this.$refs['modal-view-ban'].hide();
    },
    showBanModal(modalName, ban) {
      this.selectedBan = ban;
      this.$refs[modalName].show();
    },
  },
};
</script>

